import forOwn from 'mout/object/forOwn'

export default function countUsers(usersObj) {
  let trueUsers = []
  forOwn(usersObj, (val, key) => {
    if (val) {
      trueUsers.push(key)
    }
  })
  return trueUsers.length
}


// WEBPACK FOOTER //
// ./src/helpers/users/manageUsers/countUsers.js